module.exports = __webpack_public_path__ + "img/floor-1-nav-4.7a591bfc.png";